<template>
  <div class="dma-table">
    <sz-table :columns="columns" :table-data="tableData" v-loading="loading" />
    <div class="pagination" v-if="total > 20">
      <div style="font-size: 13px">共 {{ total }} 条</div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="20"
        layout="prev, pager, next"
        :total="total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import SzTable from "@/components/szTable/szTable.vue";
import { GetStation_residents } from "@/services/services";
import { Pagination } from "element-ui";
import dayjs from "dayjs";

export default {
  name: "DMATable",
  components: { SzTable, ElPagination: Pagination },
  props: {
    data: Object,
  },
  data() {
    return {
      columns: [
        { field: "name", label: "户名" },
        { field: "code", label: "户号" },
        { field: "flowmeter", label: "表号" },
        { field: "C3", label: "最新抄读" },
        { field: "time", label: "抄读时间" },
      ],
      tableData: [],
      currentPage: 1,
      total: 0,
      query: {
        id: null,
      },
      loading: false,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.render();
    },
    render() {
      this.loading = true;
      GetStation_residents({ id: this.data.id, page: this.currentPage }).then(
        (res) => {
          this.tableData = res.station_residents.data.map((i) => {
            let time = i.o_station.sensors.find((j) => j.unit === "C3")
              ?.o_realtime.time;
            return {
              name: i.o_station.name,
              code: i.o_station.code,
              flowmeter: i.o_flowmeter.o_device.code,
              C3:
                i.o_station.sensors.find((j) => j.unit === "C3")?.o_realtime
                  .value || 0,
              time: dayjs.unix(time).format("hh:mm"),
            };
          });
          this.total = res.station_residents.total;
          this.loading = false;
        }
      );
    },
  },
  mounted() {
    this.render();
  },
};
</script>

<style scoped lang="less">
.dma-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .pagination {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

::v-deep(.el-table) {
  font-size: 18px;

  .el-table__cell {
    padding: 10px 0;
  }
}

::v-deep.el-pagination__total {
  color: #fff;
}
</style>
